import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('googleVertex'),
  avatarPath: avatars.googleVertex,
  logoPath: logos.googleVertex
});
